import React, { useState, useEffect } from 'react';

import 'objectFitPolyfill';

import ArrowLeft from 'src/assets/icons/long-arrow-left.svg';
import ArrowRight from 'src/assets/icons/long-arrow-right.svg';
import { ButtonWrap, Button, Wrap, Slides, Slide, SwipeableContainer, Pip } from './Carousel.styled';

const Carousel = ({ slides }) => {
  const [position, setPosition] = useState(0);

  const getSlides = () => slides.slice(0, 5);

  const getOrder = slideIndex => {
    const visibleSlides = getSlides();
    const slidesCount = visibleSlides.length;

    if (slideIndex === slidesCount - 1 && !position) {
      return -1;
    }

    if (slideIndex - position < -1) {
      return slidesCount - Math.abs(slideIndex - position);
    }

    return slideIndex - position;
  };

  const prevSlide = () => {
    const visibleSlides = getSlides();

    setPosition(position === 0 ? visibleSlides.length - 1 : position - 1);
  };

  const nextSlide = () => {
    const visibleSlides = getSlides();

    setPosition(position === visibleSlides.length - 1 ? 0 : position + 1);
  };

  const setCarouselSlide = index => {
    setPosition(index);
  };

  const oneSlide = slides.length === 1;
  const twoSlides = slides.length === 2;

  return (
    <SwipeableContainer
      onSwipedLeft={nextSlide}
      onSwipedRight={prevSlide}
      preventDefaultTouchmoveEvent
      trackMouse
      oneSlide={oneSlide}
    >
      <Wrap oneSlide={oneSlide}>
        <Slides oneSlide={oneSlide} twoSlides={twoSlides}>
          {getSlides().map((slide, index) => (
            <Slide
              key={`slide_${index}`}
              flexOrder={getOrder(index)}
              centralImage={position === index}
              oneSlide={oneSlide}
            >
              {slide}
            </Slide>
          ))}
        </Slides>
        {slides.length > 1 ? (
          <ButtonWrap>
            <Button onClick={prevSlide}>
              <ArrowLeft />
            </Button>
            {getSlides().map((pip, i) => (
              <Pip active={i === position} onClick={() => setCarouselSlide(i)} key={i} />
            ))}
            <Button onClick={nextSlide}>
              <ArrowRight />
            </Button>
          </ButtonWrap>
        ) : null}
      </Wrap>
    </SwipeableContainer>
  );
};

export default Carousel;
